import { render } from "./LabPaid2Edit.vue?vue&type=template&id=f07c33a2"
import script from "./LabPaid2Edit.vue?vue&type=script&lang=js"
export * from "./LabPaid2Edit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__